import {MarkdownViewer, type MarkdownViewerProps} from '@github-ui/markdown-viewer'

import {sanitizeRenderedMarkdown} from '../../helpers/sanitize'

/**
 * A viewer for Markdown containing additional sanitizing of the received
 * rendered HTML string.
 */
export function SanitizedMarkdownViewer(props: MarkdownViewerProps) {
  const sanitizedHtml = sanitizeRenderedMarkdown(props.dangerousRenderedHTML.__html)
  return <MarkdownViewer {...props} dangerousRenderedHTML={{__html: sanitizedHtml}} />
}

try{ SanitizedMarkdownViewer.displayName ||= 'SanitizedMarkdownViewer' } catch {}